import { Branch } from '../services/branch/branch.model';

export const setAddressForGoogleMaps = (branch: Branch): string => {
  const query = encodeURIComponent(
    `${branch.LocationName},${branch.Address},${branch.City},${branch.State},${branch.Zip}`
  );
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
};
